import { render, staticRenderFns } from "./SpeedTable.vue?vue&type=template&id=4051235d&scoped=true&"
import script from "./SpeedTable.vue?vue&type=script&lang=ts&"
export * from "./SpeedTable.vue?vue&type=script&lang=ts&"
import style0 from "./SpeedTable.vue?vue&type=style&index=0&id=4051235d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4051235d",
  null
  
)

export default component.exports